// V1 Modal - Re-export from seeds-react-modal for optimal tree shaking
export {
  default as Modal,
  Modal as ModalV1,
} from "@sproutsocial/seeds-react-modal/v1";

// Explicit type exports
export type {
  TypeModalProps,
  TypeModalHeaderProps,
  TypeModalFooterProps,
  TypeModalContentProps,
  TypeModalCloseButtonProps,
} from "@sproutsocial/seeds-react-modal/v1";
